import React, {Component} from 'react';
import {observer} from "mobx-react";
import {toJS, observable, makeObservable } from "mobx";
import {checkbox, custom, input} from "../../../utils/linker";
import ImageDrop from "../../Helpers/ImageDrop";
import Portal from "../../Helpers/Portal";
import CenterScroller from "../../Helpers/CenterScroller";
import historyVars from "../../../utils/historyVars";
import MyPhotosSelector from "../../Helpers/MyPhotosSelector/MyPhotosSelector";
import Aspect from "../../Helpers/Aspect";
import LazyBg from "../../Helpers/LazyBg";

class MyPhotos extends Component {
  show_selector=false;
  constructor(props) {
    super(props);
    makeObservable(this,{
      show_selector: observable
    });
  }
  componentDidMount() {
    if(!this.props.linker.value.list) {
      this.props.linker.value.list = [];
    }
  }
  removeItem(index) {
    this.props.linker.value.list.splice(index, 1);
  }
  renderSelected() {
    if(this.props.linker.value && this.props.linker.value.list) {
      return this.props.linker.value.list.map((data,index)=>{
        return (
          <div key={data.id} className="cell mbottom15 pointer pr hov rad4 ofh">
            <Aspect className="bg-w3 rad4 ofh pr" aspect={"3:4"}>
              <LazyBg className="pa pa-tl w100 h100" style={{backgroundPosition:'center center',backgroundSize:'contain', backgroundRepeat:'no-repeat',backgroundImage:`url('${data.preview}')`}} />
            </Aspect>
            <div className="pa pa-tl w100 h100 bg-w1-op20 op-hov" onClick={()=>{ this.removeItem(index); }}>
              <div className="up12 splice h100">
                <div className="cell s-12 s-middle tac">
                  <div className="const2 mdi mdi-close fs30 lh10"></div>
                  Убрать
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
    return null;
  }
  renderSelector() {
    if(this.show_selector) {
      return (
        <CenterScroller loaded={1} unmountOverflow='visible' center={false} maxWidth={700} closeTrigger={()=>{
          this.show_selector=false;
        }} >
          <MyPhotosSelector
            already={toJS(this.props.linker.value.list)}
            onCancel={()=>{ this.show_selector=false; }}
            onSelect={(items)=>{
              this.props.linker.value.list=items;
              this.show_selector=false;
            }}
          />
        </CenterScroller>
      );
    }
    return null;
  }
  render() {
    return (
      <div className="ptop20 hpadd20 pbottom5 bg-w2 pr rad4 mbottom10">
        <div className="pa pa-tr mdi mdi-close sc1 fs24 lh10 pointer" onClick={()=>{ this.props.deleteMe(); }}></div>
        <div className="up12 margin s-size-5">
          {this.renderSelected()}
          <div className={`cell mbottom15 up12 splice bg-w1 rad4 w5 ${this.props.isOwner?"pointer":""} `} onClick={()=>{ if(this.props.isOwner) { this.show_selector=1; } }}>
            <div className="cell s-12 s-middle fs40 padd10 tac">
              {this.props.isOwner?(
                <>
                  <span className="mdi mdi-plus lh10"></span>
                  <div className="fs12">Добавить</div>
                </>
              ):(
                <div className="fs12">Нельзя добавлять фотографии из MyPhotos к чужому комментарию</div>
              )}

            </div>
          </div>
        </div>
        {this.renderSelector()}
        <div className="pbottom10">
          <label>
            <input type="checkbox" value="1" {...checkbox(this.props.linker.value,"spoiler")} /><span className="vam"></span> <span className="dib vam">Есть спойлеры</span>
          </label>
        </div>
      </div>
    )
  }
}

export default observer(MyPhotos);